__webpack_require__.p = "/space-tourism-website/";